export const isMobile = !WL_EDITOR && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
